import { supabase } from '../config/supabase'

export const initializeSupabase = async () => {
  try {
    console.log('Initializing Supabase...')
    
    // Test database connection first
    const { data: testData, error: testError } = await supabase
      .from('book_covers_bc2024')
      .select('count(*)')
      .limit(1)

    if (testError) {
      console.log('Database test:', testError.message)
    } else {
      console.log('Database connection successful')
    }

    // Check storage buckets
    const { data: buckets, error: bucketsError } = await supabase.storage.listBuckets()
    
    if (bucketsError) {
      console.log('Storage check error:', bucketsError.message)
    } else {
      console.log('Existing buckets:', buckets?.map(b => b.name))
      
      const existingBucketNames = buckets?.map(bucket => bucket.name) || []
      
      // Try to create book-covers bucket if it doesn't exist
      if (!existingBucketNames.includes('book-covers')) {
        console.log('Attempting to create book-covers bucket...')
        const { error: bucketError } = await supabase.storage.createBucket('book-covers', {
          public: true,
          allowedMimeTypes: ['image/jpeg', 'image/png', 'image/webp'],
          fileSizeLimit: 10485760 // 10MB
        })
        
        if (bucketError) {
          console.log('Book covers bucket creation error:', bucketError.message)
        } else {
          console.log('Book covers bucket created successfully')
        }
      } else {
        console.log('Book covers bucket already exists')
      }
    }

    // Test auth
    const { data: { user }, error: authError } = await supabase.auth.getUser()
    if (authError) {
      console.log('Auth test error:', authError.message)
    } else {
      console.log('Auth test successful, user:', user?.id || 'not logged in')
    }

    console.log('Supabase initialization complete')
    return true
  } catch (error) {
    console.error('Supabase initialization error:', error)
    return true // Continue even if there are setup issues
  }
}

export const createStorageBuckets = async () => {
  try {
    console.log('Creating storage buckets...')
    
    // Create book-covers bucket
    const { error: coversError } = await supabase.storage.createBucket('book-covers', {
      public: true,
      allowedMimeTypes: ['image/jpeg', 'image/png', 'image/webp'],
      fileSizeLimit: 10485760 // 10MB
    })
    
    if (coversError && !coversError.message.includes('already exists')) {
      console.error('Error creating book-covers bucket:', coversError)
    } else {
      console.log('Book-covers bucket ready')
    }

    // Create generated-mockups bucket
    const { error: mockupsError } = await supabase.storage.createBucket('generated-mockups', {
      public: true,
      allowedMimeTypes: ['image/jpeg', 'image/png', 'application/pdf'],
      fileSizeLimit: 20971520 // 20MB
    })
    
    if (mockupsError && !mockupsError.message.includes('already exists')) {
      console.error('Error creating generated-mockups bucket:', mockupsError)
    } else {
      console.log('Generated-mockups bucket ready')
    }

    return true
  } catch (error) {
    console.error('Error creating storage buckets:', error)
    return false
  }
}